import AWS from "aws-sdk";

const getS3Client = (region, identityPool) => {

    AWS.config.update({
        region: region,
        credentials: new AWS.CognitoIdentityCredentials({
            IdentityPoolId: identityPool
        }),
        maxRetries: 3
    });

    return new AWS.S3();
}

export { getS3Client };